import React from "react";
import EditProfile from "../../components/public/editProfile";
import { GetStart, About, Courses, Trainer } from "../../components";
import PrivateContainer from "./privateContainer";
import TrainersList from "../../components/trainersList";
import AboutUs from "../../components/aboutUs";
import Terms from "../../components/terms";
import Advisors from "../../components/advisor";
import AllCourses from "../../components/allCourses";

  const Dashboard=() => {return (<div>
  <GetStart isPublic={false}/>
  <About />
  <Courses />
  <Trainer />
</div>)}

// const NotFound = (props) => {
//   const { history } = props;
//   function timeout() {
//     setTimeout(function(){ history.push("/") }, 2000);
//   }
//   return <section id="about" className="about">
//     <div style={{ display: "flex", justifyContent: "center", marginTop: 75 }}>
//       <h1>Not Found</h1>
//       {timeout()}
//     </div>
//   </section>;
// }

const route = [
  {path: "/", component: Dashboard},
  {path: "/edit-profile", component: EditProfile},
  {path: "/trainers", component: TrainersList},
  {path: "/abouts", component: AboutUs},
  {path: "/term", component: Terms},
  {path: "/advisors", component: Advisors},
  {path: "/course", component: AllCourses},
  // {path: "*", component: NotFound},
];

const privateRoute=route.map((item) => (
  <PrivateContainer exact path={item.path} component={item.component} key={item.path} />
))

export default privateRoute;